import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  QueryList,
  ViewChildren,
  OnDestroy,
  OnInit
} from '@angular/core';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive
} from '@angular/router';
import { AsyncPipe, NgClass, NgIf, NgOptimizedImage, NgStyle } from '@angular/common';
import { combineLatest, Subscription } from 'rxjs';

import { LayoutService } from '../../../../core/services/layout.service';
import { SafeHtmlPipe } from '../../../../shared/pipes/safe-html.pipe';

export interface NavItem {
  name: string;
  icon: string;
  path?: string;
  new?: boolean;
  adminOnly?:boolean;
subItems ?: {
  name: string;
  path: string;
  pro?: boolean;
  new?: boolean;
}[];
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, AsyncPipe, SafeHtmlPipe, NgClass, NgStyle],
  templateUrl: './app-sidebar.component.html',
  styleUrl: './app-sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppSidebarComponent implements OnInit, OnDestroy {

  filteredNavItems: NavItem[] = [];

  userType: string = '';

  /* =====================
     MENU DATA
  ====================== */
  navItems: NavItem[] = [
    {
      icon: '📅',
      name: 'திருவிழாக்கள்',
      path: '/main/events',
      adminOnly: true
    },
    {
      icon: '📝',
      name: 'திருவிழா விவரங்கள்',
      path: '/main/event-details',
      adminOnly: true
    },
    {
      icon: '🌾',
      name: 'முளைப்பாரி பதிவு',
      path: '/main/mulaipari-entry'
    },
    {
      icon: '📑',
      name: 'முளைப்பாரி விவரங்கள்',
      path: '/main/mulaipari-details'
    },
    {
      icon: '🥛',
      name: 'பால்குடம் பதிவு',
      path: '/main/paalkudam-entry'
    },
    {
      icon: '📄',
      name: 'பால்குடம் விவரங்கள்',
      path: '/main/paalkudam-details'
    },
    {
      icon: '💝',
      name: 'நன்கொடை பதிவு',
      path: '/main/donation-entry'
    },
    {
      icon: '📋',
      name: 'நன்கொடை விவரங்கள்',
      path: '/main/donation-details'
    }
  ];

  othersItems: NavItem[] = [ /* SAME DATA – unchanged */];

  /* =====================
     UI STATE
  ====================== */
  openSubmenu: string | null = null;
  subMenuHeights: Record<string, number> = {};

  @ViewChildren('subMenu') subMenuRefs!: QueryList<ElementRef>;

  readonly isExpanded$;
  readonly isMobileOpen$;
  readonly isHovered$;

  private subscription = new Subscription();

  constructor(
    public layoutService: LayoutService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.isExpanded$ = this.layoutService.isExpanded$;
    this.isMobileOpen$ = this.layoutService.isMobileOpen$;
    this.isHovered$ = this.layoutService.isHovered$;
  }

  /* =====================
     LIFECYCLE
  ====================== */
  ngOnInit(): void {
     this.loadUserMenu();
    this.subscription.add(
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.setActiveMenuFromRoute(event.urlAfterRedirects);
        }
      })
    );

    this.subscription.add(
      combineLatest([
        this.isExpanded$,
        this.isMobileOpen$,
        this.isHovered$
      ]).subscribe(() => {
        this.cdr.markForCheck();
      })
    );

    this.setActiveMenuFromRoute(this.router.url);
  }

    private loadUserMenu(): void {

  const userData = localStorage.getItem('user');

  if(userData){

    const user = JSON.parse(userData);

    this.userType = user.userType;

  }


  if(this.userType === 'ADMIN'){

    this.filteredNavItems = this.navItems;

  }
  else {

    this.filteredNavItems = this.navItems.filter(
      item => !item.adminOnly
    );

  }


  this.cdr.markForCheck();

}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /* =====================
     UI EVENTS
  ====================== */
  onMouseEnter() {
    if (window.innerWidth >= 1200) {
      this.layoutService.setHovered(true);
    }
  }

  onMouseLeave() {
    if (window.innerWidth >= 1200) {
      this.layoutService.setHovered(false);
    }
  }

  isActive(path: string): boolean {
    return this.router.url === path;
  }

  toggleSubmenu(section: string, index: number): void {
    const key = `${section}-${index}`;

    if (this.openSubmenu === key) {
      this.openSubmenu = null;
      this.subMenuHeights[key] = 0;
      return;
    }

    this.openSubmenu = key;

    queueMicrotask(() => {
      const el = document.getElementById(key);
      if (el) {
        this.subMenuHeights[key] = el.scrollHeight;
        this.cdr.markForCheck();
      }
    });
  }

  onSubmenuClick(): void {
    this.layoutService.setMobileOpen(false);
  }

  /* =====================
     ROUTE HANDLING
  ====================== */
  private setActiveMenuFromRoute(url: string): void {

  const groups = [
    { 
      items: this.filteredNavItems, 
      prefix: 'main' 
    },
    { 
      items: this.othersItems, 
      prefix: 'others' 
    }
  ];


  for (const group of groups) {

    group.items.forEach((item,index)=>{

      item.subItems?.forEach(sub=>{

        if(sub.path === url){

          const key = `${group.prefix}-${index}`;

          this.openSubmenu = key;


          queueMicrotask(()=>{

            const el = document.getElementById(key);

            if(el){

              this.subMenuHeights[key] = el.scrollHeight;

              this.cdr.markForCheck();

            }

          });

        }

      });

    });

  }
}

  closeSidebar() {
    this.layoutService.setMobileOpen(false);
  }

}
